import React from 'react';
import SearchMenu, { FilterConsumer } from '../components/SearchMenu';
import AdvancedEvent from './AdvancedEvent';

function AdvancedEventsSearch() {
  return (
    <SearchMenu>
      <FilterConsumer>{(AgencyFilter) => <AdvancedEvent filter={AgencyFilter} />}</FilterConsumer>
    </SearchMenu>
  );
}

export default AdvancedEventsSearch;
